import dayjs from "dayjs";

import { apiFormat } from "@similarweb/pro-logic-components";

import DurationService from "app/services/DurationService";

import { useDisplayAdvertiserPublisherDataAndParams } from "./useDisplayAdvertiserPublisherDataAndParams";

export const useDurationSubtitleFilter = (startDate?: dayjs.ConfigType, endDate?: dayjs.ConfigType) => {
    const params = useDisplayAdvertiserPublisherDataAndParams();
    const { from, to } = DurationService.getDurationData(params.duration).forAPI;
    const fromFormatted = startDate ? dayjs(startDate).format(apiFormat) : from;
    const toFormatted = endDate ? dayjs(endDate).format(apiFormat) : to;

    return {
        filter: "date" as const,
        value: { from: fromFormatted, to: toFormatted },
    };
};
